import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { comparisonRows } from '../data/content';
export function CostSection() {
  return <section className="w-full border-y border-ink-800 bg-ink-900 py-20" aria-labelledby="costo-title" data-id="element-42" data-mp="9cq0iseg386i">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-43" data-mp="4iv9f3wifqxe">
        <h2 id="costo-title" className="font-display text-3xl font-900 leading-tight text-white sm:text-4xl" style={{
        fontSize: "28px"
      }} data-id="element-44" data-mp="3vqpsow6qlct5">
          ¿Cuánto cuesta NO tenerlo?
        </h2>
        <p className="mt-3 max-w-2xl text-lg text-slate-300" data-id="element-45" data-mp="3mprskozf5pfu">
          El verdadero coste no es lo que pagas. Es lo que sigues perdiendo cada mes por decidir sin
          información.
        </p>

        <div className="mt-10 overflow-x-auto rounded-2xl border border-ink-800" data-id="element-46" data-mp="3ctolr5tmh2mk">
          <table className="w-full min-w-[640px] border-collapse text-left" data-id="element-47" data-mp="1g0mul2l2lpe0">
            <caption className="sr-only" data-id="element-48" data-mp="1b1jodetctd4g">
              Comparación entre gestionar tu proyecto solar con y sin El Código Solar 360°
            </caption>
            <thead data-id="element-49" data-mp="p60buortbqh1">
              <tr className="bg-ink-950" data-id="element-50" data-mp="p9o1hcu4zsqh">
                <th scope="col" className="px-5 py-4 font-display text-xs font-700 uppercase tracking-[0.18em] text-slate-400" data-id="element-51" data-mp="t9f2089gtn87">
                  Situación real
                </th>
                <th scope="col" className="px-5 py-4 font-display text-xs font-700 uppercase tracking-[0.18em] text-alert" data-id="element-52" data-mp="k90bmuhn9hxu">
                  Sin Código Solar
                </th>
                <th scope="col" className="px-5 py-4 font-display text-xs font-700 uppercase tracking-[0.18em] text-leaf-400" data-id="element-53" data-mp="y89k17zlz7r9">
                  Con Código Solar
                </th>
              </tr>
            </thead>
            <tbody data-id="element-54" data-mp="1qvm6li5rrfkk">
              {comparisonRows.map(row => <tr key={row.situation} className="border-t border-ink-800" data-id="element-55" data-mp="1vop05qajqp0r">
                  <th scope="row" className="px-5 py-4 text-sm font-600 text-white" data-id="element-56" data-mp="25k5oaqjwr6rc">
                    {row.situation}
                  </th>
                  <td className="px-5 py-4 text-sm text-slate-400" data-id="element-57" data-mp="20lcb6z8j9hrp">
                    <span className="flex items-center gap-2" data-id="element-58" data-mp="1vkeukr368vsb">
                      <XIcon className="h-4 w-4 flex-none text-alert" aria-hidden="true" data-id="element-59" data-mp="1rjux1meorq5n" />
                      {row.without}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-sm text-slate-100" data-id="element-60" data-mp="1mmurdclr0pf2">
                    <span className="flex items-center gap-2" data-id="element-61" data-mp="1ht9pvaky5db4">
                      <CheckIcon className="h-4 w-4 flex-none text-leaf-400" aria-hidden="true" data-id="element-62" data-mp="1cuoz01rl45zc" />
                      {row.with}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}